exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-gallery-tsx": () => import("./../../../src/pages/gallery.tsx" /* webpackChunkName: "component---src-pages-gallery-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-mdx-slug-tsx": () => import("./../../../src/pages/{mdx.slug}.tsx" /* webpackChunkName: "component---src-pages-mdx-slug-tsx" */),
  "component---src-pages-reservation-tsx": () => import("./../../../src/pages/reservation.tsx" /* webpackChunkName: "component---src-pages-reservation-tsx" */)
}

